import { ApiClient } from "../../api/client";
import { ApiServer } from "../../api/server";

/**
 * Клиентский диспатчер разделов — браузер.
 * Через ApiClient.sections: относительный /api и отсечка ботов.
 * Использовать в компонентах (useEffect и т.п.).
 */
export const fetchSections = (reset = false) => {
  return async (dispatch) => {
    const response = await ApiClient.sections.getSections(reset);
    // При неудаче (ошибка запроса или пропуск для бота) НЕ диспатчим ничего.
    // Раньше сюда уходил свежий литерал `[]`: ссылка в сторе менялась, лейауты
    // с useEffect(..., [sections]) и проверкой `sections.length === 0` считали
    // это изменением состояния и запрашивали снова — один сбой раскручивался в
    // бесконечный цикл запросов (запрос каждые ~6 мс) и событий в GlitchTip.
    // Без диспатча ссылка остаётся прежней, эффект не перезапускается, и
    // повторная попытка случится штатно — на следующем монтировании/навигации.
    if (!response) {
      return;
    }
    dispatch({ type: "FETCH_SECTIONS", payload: response });
  };
};

/**
 * Серверный диспатчер разделов — SSR.
 * Через ApiServer.sections: прямой запрос в Bitrix bxApi с кэшем в Redis, без
 * лишнего HTTP round-trip. Использовать в getServerSideProps; Redis приходит
 * оттуда же.
 */
export const fetchSectionsServer = (reset = false, Redis = false) => {
  return async (dispatch) => {
    const response = await ApiServer.sections.getSections(Redis, reset);
    dispatch({ type: "FETCH_SECTIONS", payload: response || [] });
  };
};
